export enum AppEnvironment {
    Development = 'Development',
    Beta = 'Beta',
    Production = 'Production',
    Unknown = 'Unknown',
}
